import { gql } from '@apollo/client';

export const ALERTS_UNSUBSCRIBE = gql`
  mutation ($email: String!, $type: String!, $searchId: String) {
    unsubscribe(email: $email, type: $type, searchId: $searchId)
  }
`;

// Separate document so links without `newsletter` keep using the old shape
// and never depend on the backend supporting `newsletterId`
export const ALERTS_UNSUBSCRIBE_FROM_NEWSLETTER = gql`
  mutation ($email: String!, $type: String!, $newsletterId: String!) {
    unsubscribe(email: $email, type: $type, newsletterId: $newsletterId)
  }
`;

export const SUBSCRIBE_FOR_BLOG_ALERTS = gql`
  mutation ($email: String!, $leadId: String, $browserUUID: String) {
    subscribeUserForBlog(
      email: $email
      leadId: $leadId
      browserUUID: $browserUUID
    )
  }
`;

export const CHANGE_BLOG_SUBSCRIPTION_FREQUENCY = gql`
  mutation ($email: String!, $frequency: String!) {
    changeBlogSubscriptionFrequency(email: $email, frequency: $frequency)
  }
`;

// Profile page only: `source` lets the API count a switch to Never as an
// unsubscribe, unlike sign-up flows that also send Never
export const CHANGE_BLOG_SUBSCRIPTION_FREQUENCY_FROM_PROFILE = gql`
  mutation ($email: String!, $frequency: String!, $source: String) {
    changeBlogSubscriptionFrequency(
      email: $email
      frequency: $frequency
      source: $source
    )
  }
`;

export const SEND_CONTACT_US_FORM = gql`
  mutation (
    $Name: String!
    $Email: String!
    $Phone: String
    $BuildingName: String
    $BuildingAvgPrice: Float
    $IsPreConstruction: Boolean
    $Comments: String!
    $PageName: String
    $LeadType: String
    $BuildingAndUnit: String
    $Neighborhood: String
    $City: String
    $UnitPrice: String
    $UnitPriceInt: Int
    $UnitUrl: String
    $UnitAddress: String
    $UnitNumber: String
    $UnitZip: String
    $PpcUser: Boolean
    $RecaptchaToken: String
    $FormLoaded6tY4bPYk: String
    $PhoneNumber6tY4bPYk: String
    $agent: String
    $leadId: String
    $pageUrl: String
    $browserUUID: String
    $isOwnerRequest: Boolean
    $medianPrice: Float
    $smsConsent: Boolean
    $MlsNumber: String
    $PropertyType: String
    $BuildingSlug: String
    $ListOfficeMlsId: String
    $MlsOfficeName: String
  ) {
    sendContactUsForm(
      buildingAndUnit: $BuildingAndUnit
      buildingName: $BuildingName
      buildingAvgPrice: $BuildingAvgPrice
      isPreConstruction: $IsPreConstruction
      city: $City
      comments: $Comments
      email: $Email
      leadType: $LeadType
      name: $Name
      neighborhood: $Neighborhood
      pageName: $PageName
      phone: $Phone
      ppcUser: $PpcUser
      recaptchaToken: $RecaptchaToken
      unitAddress: $UnitAddress
      unitNumber: $UnitNumber
      unitPrice: $UnitPrice
      unitPriceInt: $UnitPriceInt
      unitUrl: $UnitUrl
      unitZip: $UnitZip
      formLoaded6tY4bPYk: $FormLoaded6tY4bPYk
      phoneNumber6tY4bPYk: $PhoneNumber6tY4bPYk
      agent: $agent
      leadId: $leadId
      pageUrl: $pageUrl
      browserUUID: $browserUUID
      isOwnerRequest: $isOwnerRequest
      medianPrice: $medianPrice
      smsConsent: $smsConsent
      mlsNumber: $MlsNumber
      propertyType: $PropertyType
      buildingSlug: $BuildingSlug
      listOfficeMlsId: $ListOfficeMlsId
      mlsOfficeName: $MlsOfficeName
    )
  }
`;

// Upgrades a just-submitted contact/lead to SMS consent = YES.
// Fired only by the "ONE MORE THING" popup's "Yes" action. Keyed by leadId
// (preferred) or email/phone/browserUUID. See SMS consent (A2P 10DLC) plan.
export const UPGRADE_SMS_CONSENT = gql`
  mutation (
    $consent: Boolean!
    $email: String
    $phone: String
    $leadId: String
    $browserUUID: String
  ) {
    upgradeSmsConsent(
      consent: $consent
      email: $email
      phone: $phone
      leadId: $leadId
      browserUUID: $browserUUID
    )
  }
`;
